import { ChangeDetectorRef, Component, DoCheck, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { faChevronDown, faFilter } from '@fortawesome/free-solid-svg-icons';
import { NgSelectComponent } from '@ng-select/ng-select';
@Component({
  selector: 'filtro-dados',
  templateUrl: './filtro-dados.component.html',
  styleUrls: ['./filtro-dados.component.css']
})
export class FiltroDadosComponent implements DoCheck {
  @Input() pageItens!: number;
  @Input() totalItens!: number;
  @Output() changeQuantidade: EventEmitter<number> = new EventEmitter();
  @ViewChild('Selecter') ngselect!: NgSelectComponent;
  //Icones
  faFilter = faFilter;
  faChevron = faChevronDown;
  valorAnterior: number = 5;
  itens: Array<{ id: number, name: number }> = [
    { id: 5, name: 5 },
    { id: 10, name: 10 },
    { id: 20, name: 20 },
    { id: 50, name: 50 }
  ];
  constructor(@Inject(ChangeDetectorRef) private changeDetector: ChangeDetectorRef) { }
  ngDoCheck(): void {
    if (this.pageItens != this.valorAnterior) {
      this.valorAnterior = this.pageItens;
      setTimeout(() => {
        this.changeQuantidade.emit(this.pageItens);
        this.changeDetector.detectChanges();
      });
    }
  }
}
